/*
 * @Author: Zhouqi
 * @Date: 2025-10-21 16:53:42
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-04-20 18:32:14
 */

import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

import baseConfig from '@/config';

const key = 'f_text_to_video_state';

type TextToVideoState = {
  formValues: {
    [key: string]: any;
  };
  setFormValues: (values: Partial<TextToVideoState['formValues']>) => void;
  reset: () => void;
};

const initialData: TextToVideoState['formValues'] = {
  modelID: 15,
};

export const stripTextToVideoPersistedFormValues = <
  T extends TextToVideoState['formValues'],
>(
  values: T,
): T => {
  const { reference_images, reference_videos, reference_audios, ...rest } = values;
  return rest as T;
};

export const useTextToVideoStore = createWithEqualityFn<TextToVideoState>()(
  devtools(
    persist(
      (set) => ({
        formValues: initialData,
        setFormValues: (values: Partial<TextToVideoState['formValues']>) =>
          set(() => ({ formValues: values })),
        reset: () => {
          set({ formValues: { ...initialData } });
        },
      }),
      {
        name: key,
        storage: createJSONStorage(() => localStorage),
        partialize: ({ formValues }) => ({
          formValues: stripTextToVideoPersistedFormValues(formValues),
        }),
      },
    ),
    {
      name: key,
      enabled: baseConfig.debuggable,
    },
  ),
);
